export function NotFoundPage() {
	return (
		<div className="flex flex-col items-center justify-center">
			<h1 style={{ fontSize: "5rem", color: "#333" }}>404</h1>
			<p style={{ fontSize: "2rem", color: "#666" }}>Page Not Found</p>
		</div>
	);
}
